import React, { useEffect, useState } from 'react'
import { IRequestedItem, IRequestedItemAllocation, ItemsRequestModel } from '.'
import ItemsApp, { IInventoryModel } from '../items/ItemsApp'
import BasicModalWindow from '../../components/BasicModalWIndow'
import { useDispatch } from 'react-redux'
import { handleRequestError } from '../../services/api'
import { SingleItemInventoryBox } from '../items/ItemInventory'
import { Button, Skeleton } from '@mui/material'
import QuantitySlider from '../transactions/QuantitySlider'
import ItemsRequestsApp from './ItemsRequestsApp'

interface IItemAllocationsProps {
    open: boolean,
    handleClose: () => void,
    requestedItem: IRequestedItem,
    requestedItems: IRequestedItem[],
    setItems: (items: IRequestedItem[]) => void,
    updateAllocationsForItem: (itemId: number, updatedAllocation: IRequestedItemAllocation) => void,
    viewRequestPage?: boolean,
    request?: ItemsRequestModel | null
}

export default function ItemAllocations(props: IItemAllocationsProps) {

    const dispatch = useDispatch()

    const { open, handleClose, requestedItem, requestedItems, setItems, updateAllocationsForItem, viewRequestPage, request } = props

    const [inventory, setInventory] = useState<IInventoryModel[]>([])
    const [loading, setLoading] = useState<boolean>(false)
    const [hasLoaded, setHasLoaded] = useState<boolean>(false)

    const [quantityModal, setQuantityModal] = useState<boolean>(false)

    const [quantity, setQuantity] = useState<number>(0)
    const [maxQuantity, setMaxQuantity] = useState<number>(0)

    const [currentInventory, setCurrentInventory] = useState<IInventoryModel | null>()

    const itemsApp = new ItemsApp()
    const itemsRequestApp = new ItemsRequestsApp()

    /**
     * Load inventory
     */
    const loadInventory = () => {
        // if (hasLoaded){
        //     return;
        // }

        setLoading(true)

        itemsApp.itemInventory(requestedItem.item.unique_id)
            .then(response => {

                const list = response.data
                setInventory(list)
                setLoading(false)
                // setHasLoaded(true)

            })
            .catch(error => {
                handleRequestError(error, dispatch)
            })

    }

    useEffect(() => {
        loadInventory()
    }, [open])

    /**
     * Handle close quantity modal
     */
    const handleHideQuantityModal = () => {
        setQuantityModal(false)
        setCurrentInventory(null)
        setQuantity(0)
        setMaxQuantity(0)
        handleClose()
    }

    /**
     * Handle open quantity modal
     */
    const handleOpenQuantityModal = (inventory: IInventoryModel) => {
        setQuantityModal(true)

        let quantity: number = inventory.quantity

        if (request && request.status === "pending"){
            quantity = inventory.reserved_quantity + inventory.quantity
        }

        setMaxQuantity(quantity)
        setCurrentInventory(inventory)

        setQuantity(1)
    }

    /**
     * Custom buttons
     */
    const customButtons = (inventory: IInventoryModel) => {

        const renderButton = () => {

            let disabled: boolean = false

            if (request && request.status === "pending"){
               
            }else{
                 if (inventory.quantity === 0){
                    disabled = true
                }
            }

            return <Button disabled={disabled} className="general-button admin-button" color="success" onClick={() => handleOpenQuantityModal(inventory)}>Update Quantity</Button>
        }

        if (request && request.status === "pending"){
            return renderButton()
        }

        if (viewRequestPage){
            return <></>
        }

        return renderButton()
    }

    /**
     * Render inventory
     */
    const renderInventory = () => {

        if (loading){
            return(
                <>
                    <Skeleton variant="rectangular" width={"100%"} height={100} style={{ marginBottom: 10 }} />
                    <Skeleton variant="rectangular" width={"100%"} height={100} style={{ marginBottom: 10 }} />
                    <Skeleton variant="rectangular" width={"100%"} height={100} style={{ marginBottom: 10 }} />
                </>
            )
        }

        return inventory.map((item, index) => <SingleItemInventoryBox viewRequestPage={request && request.status === "pending" ? false : viewRequestPage} {...item} key={index} customButtons={customButtons} />)
    }

    /**
     * 
     */
    const setAllocations = () => {
        if (!currentInventory){
            return;
        }

        const executeUpdateAllocationsFunc = () => {
            updateAllocationsForItem(requestedItem.item_id, {
                warehouseId: currentInventory.warehouse_id,
                sectionId: currentInventory.section_id,
                locationId: currentInventory.location_id,
                quantity: quantity
            })

            handleHideQuantityModal()
        }

        if (request && request.status === "pending"){
            itemsRequestApp.updateRequestedItemAllocations(request.request_number, requestedItem.item_id, currentInventory.warehouse_id, currentInventory.section_id, currentInventory.location_id, quantity)
                .then(response => {

                    const { data } = response
                    const updatedItem: IRequestedItem = data.requested_item

                    let newRequestedItems = [...requestedItems]

                    if (newRequestedItems.find((item) => item.item_id === requestedItem.item_id)){
                        const findIndex = newRequestedItems.findIndex((item) => item.item_id === requestedItem.item_id)

                        if (newRequestedItems[findIndex]){
                            newRequestedItems[findIndex] = updatedItem
                        }
                    }

                    setItems(newRequestedItems)

                    handleHideQuantityModal()
                })
                .catch(error => {
                    handleRequestError(error, dispatch)
                })
        }else{
            executeUpdateAllocationsFunc()
        }

    }

    return(
        <BasicModalWindow
            shown={open}
            handleClose={handleClose}
            size="md"
            actionButtons={[
                {
                    label: "Refresh",
                    onClick: () => loadInventory(),
                    color: "success"
                },
                {
                    label: "Close",
                    onClick: handleClose,
                    color: "error"
                }
            ]}
            actionButtonsBottom
            showHeader
            title={`Allocations: ${requestedItem.item.title}`}
        >

            <BasicModalWindow
                shown={quantityModal}
                handleClose={handleHideQuantityModal}
                size="sm"
                showHeader
                title="Quantity"
                actionButtons={[
                    {
                        label: "Done",
                        onClick: setAllocations,
                        color: "success"
                    },
                    {
                        label: "Close",
                        onClick: handleHideQuantityModal,
                        color: "error"
                    }
                ]}
                actionButtonsBottom
            >
                <QuantitySlider itemMaxAvailableQnt={maxQuantity} quantity={quantity} updateQuantity={(qnt) => setQuantity(qnt)} />
            </BasicModalWindow>

            <div>
                {renderInventory()}
            </div>
        </BasicModalWindow>
    )
}